import type { OrderItemData } from "@Modules/shoppingcart/Data/Models/OrderModel";

/**
 * The copy naming why an item was cancelled. The same code means different things per item
 * type, so both halves go into the key: code 2 reads "Not available" on a purchase and
 * "Already subscribed" on a renewal service. An item cancelled without a recorded
 * reason falls back to the bare "Cancelled" so a raw key never reaches the screen.
 */
export function cancellationReasonKey(item: OrderItemData): string {
  if (item.cancellation_reason === null) {
    return "shoppingCart.cancelled";
  }

  return `shoppingCart.cancellation.${item.type}.${item.cancellation_reason}`;
}
